<div class="validation-failed__container">
  <p class="validation-failed__error-message" translate>{{error}}</p>
  <a href="https://voxloud.cloudflareaccess.com/#/Launcher" class="validation-failed__action vox-btn vox-btn-primary"
    translate>auth.login.cloudflare-link</a>
</div>